import { toast } from 'sonner';

/** Picker value for a server column suggestion ('' when there is none). */
export function suggestedColumnValue(index: number | null | undefined): string {
  return index != null ? String(index) : '';
}

/**
 * Re-preview an already-uploaded workbook from another worksheet (no
 * re-upload). Shared by the two-phase upload dialogs: guards the no-op cases,
 * hands the fresh preview to `onPreview`, and surfaces a failure as a toast
 * (after `onError`, for callers that need to revert an optimistic pick).
 */
export async function repreviewWorkbookSheet<T extends { sheetName: string }>({
  documentId,
  currentSheetName,
  nextSheetName,
  preview,
  onPreview,
  onError,
  fallbackMessage,
}: {
  documentId: string | null;
  currentSheetName: string | null;
  nextSheetName: string;
  preview: (input: { documentId: string; sheetName: string }) => Promise<T>;
  onPreview: (result: T) => void;
  onError?: () => void;
  fallbackMessage: string;
}): Promise<void> {
  if (!documentId || nextSheetName === currentSheetName) return;
  try {
    onPreview(await preview({ documentId, sheetName: nextSheetName }));
  } catch (err) {
    onError?.();
    toast.error(err instanceof Error ? err.message : fallbackMessage);
  }
}
